import React from "react";
import "../../../styles/sidebar.scss";
import { subDirectory } from "../../../config.json";
import * as InoIcons from "react-icons/io";
import { getLocalStorageValues, localstore } from "../../../services/authService";
import { ClearCookie } from "../../../services/boat";

class SideNav extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      state: {
        showNav: false,
        loggedIn: false,
      },
    };
  }

  componentDidMount = async () => {
    console.log(this.props);
    let UserId = getLocalStorageValues("UserId");
    if (UserId === "") {
      console.log("UserId");
      await this.setState({
        loggedIn: false,
      });
    } else {
      await this.setState({
        loggedIn: true,
      });
    }
  };

  openNavClick = (e) => {
    e.preventDefault();
    this.openNav();
  };

  closeNavClick = (e) => {
    e.preventDefault();
    this.closeNav();
  };

  logout = async () => {
    localStorage.clear();
    await ClearCookie();
    this.closeNav();
    window.location.replace(`${subDirectory}/boat`);
  };

  localstore = async (key, UserId) => {
    await localstore(key, UserId);
  };

  openNav = () => {
    this.setState({
      showNav: true,
    });
    document.getElementById("overlay").style.display = "block";

    document.addEventListener("keydown", this.handleEscKey);
  };

  closeNav = () => {
    this.setState({
      showNav: false,
    });
    document.getElementById("overlay").style.display = "none";
    document.removeEventListener("keydown", this.handleEscKey);
  };

  handleEscKey = (e) => {
    if (e.key === "Escape") {
      this.closeNav();
    }
  };

  render() {
    const { showNav, loggedIn } = this.state;
    let navCoverStyle = { width: showNav ? "100%" : "0" };
    let sideNavStyle = { width: showNav ? "30%" : "0"   };

    return (
      <React.Fragment>
        <span onClick={this.openNavClick} class="open-nav">
          {/* &#9776;  */}
          <InoIcons.IoIosMenu />
        </span>
        <div onClick={this.navCoverClick} class="nav-cover" style={navCoverStyle} />
        <div name="side-nav" class="side-nav" style={sideNavStyle}>
          <a href="#" onClick={this.closeNavClick} class="close-nav">
            &times;
          </a>
          <a href={`${subDirectory}/boatBookingHistory`} className="side-nav-item">
            Booking History
          </a>
          <a href={`${subDirectory}/boatBookingCancellation`} className="side-nav-item">
            Cancellation
          </a>

          <a href={`${subDirectory}/Reschedule`} className="side-nav-item">
            Reschedule
          </a>

          <a href={`${subDirectory}/boatTripHistory`} className="side-nav-item">
            Trip History
          </a>

          <a href={`${subDirectory}/public-profile`} className="side-nav-item">
            Profile
          </a>

          <a href={`${subDirectory}/changePassword`} className="side-nav-item">
            Change Password
          </a>

          <a href={`${subDirectory}/boardingPass`} className="side-nav-item">
            Boarding Pass
          </a>

          <a href={`${subDirectory}/counterPin`} className="side-nav-item">
            Counter Pin
          </a>
          <a onClick={this.logout} className="side-nav-item">
            Logout
          </a>
        </div>
        <div id="overlay" onClick={this.closeNavClick}></div>
      </React.Fragment>
    );
  }
}

export default SideNav;
